import { IPassengerEnvironment } from '@mopla/utils';

export const environment: IPassengerEnvironment = {
	production: true,
	baseUrl: 'https://backend.staging.mopla.solutions',
	sentryDns:
		'https://6178e46eb58a27c59aed5eedf11915aa@o1355916.ingest.us.sentry.io/6643623',
	env: 'staging',
	ticketshopBaseUrl: 'https://ticketshop.staging.mopla.solutions/',
	paymentBaseUrl: 'https://payment.staging.mopla.solutions',
	stripePublicKey:
		'pk_test_51SQP7vB8cG4j7f4SfdYPXKELuH8frgAOEwmDBk5EC21UPAOFEraG4rCZmyKccyNQ1Bop2jdH38PLNcsrEaY3hxVP001UmSniVI',
	stripeCustomCloseCallback: 'mopla.passenger.staging://?isPaymentRedirect',
	stripeWebCallback: 'https://app.staging.mopla.solutions',
	stripeNativeCallback: 'https://payment.staging.mopla.solutions',
	firebaseConfig: {
		apiKey: 'AIzaSyBwes4dXu5n5WBi71hErW9LD9BSDmthzdQ',
		authDomain: 'mopla-staging.firebaseapp.com',
		projectId: 'mopla-staging',
		storageBucket: 'mopla-staging.appspot.com',
		messagingSenderId: '704166027041',
		appId: '1:704166027041:web:020d999e262f3749d56860',
	},
	spenditValidationSetSource:
		'https://staging.mybenefits.spendit.de/.well-known/openid-configuration',
	showLiveUpdatesVersion: true,
	trueLayerRedirectUrl:
		'https://app.staging.mopla.solutions/?truelayer_redirect=true',
	trueLayerDeepLink:
		'mopla.passenger.staging://auth-callback?truelayer_redirect=true',
	trueLayerAuthLinkWeb:
		'https://auth.truelayer-sandbox.com/?response_type=code&client_id=sandbox-moplapassenger-0e0708&scope=verification&providers=uk-cs-mock%20uk-ob-all%20uk-oauth-all&redirect_uri=https://app.staging.mopla.solutions/?truelayer_redirect=true',
	trueLayerAuthLinkNative:
		'https://auth.truelayer-sandbox.com/?response_type=code&client_id=sandbox-moplapassenger-0e0708&scope=verification&providers=uk-cs-mock%20uk-ob-all%20uk-oauth-all&redirect_uri=mopla.passenger.staging://auth-callback?truelayer_redirect=true',
	enableOpenBanking: true,
	basename: '',
	recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	deutschlandTicket: {
		priceChangeDate: '2026-01-01',
		oldPrice: 58,
		newPrice: 63,
		messageVisibleFrom: '2025-11-01',
		messageVisibleUntil: '2026-02-01',
	},
	featureFlags: {
		PRODTVouchersFeatureFlag: true,
		priorityDistributorIds: [
			'a10a0cf3-416b-4921-890f-3a36fb51a48d', // Saalekreis Nord Test
			// PNVG Staging (4 distributors, same config)
			'2871ba76-8bf5-475b-b523-f018e1a9e9f0',
			'a205106c-c75a-4b7d-996d-22b491bb55d5',
			'40439c44-fb7c-4bf0-b97c-9e696d83bda1',
			'fe264e0e-cf7e-475a-861e-44c31fb2a30e',
		],
	},
	googleTagManager: {
		googleTagManagerContainerId: 'GTM-W85G5NR8',
	},
	// TODO: Re-enable 'facebook' login after fixing iOS authentication issue.
	// Also requires Firebase configuration for production environment.
	allowedSocialLoginMethods: ['google', 'apple'],
};
